import { createContext, useContext } from 'react';
import type { VirtualScrollContextState as Context } from '../types';
import useEventsHandler from './useEventsHandler';

export const VirtualScrollContext = createContext<Context>({} as Context);

export const useVirtualScroll = () => {
  const context = useContext(VirtualScrollContext);
  const { handleKeyEvent } = useEventsHandler(context);

  if (!context) {
    throw new Error(
      'useVirtualScroll must be used within a VirtualScrollProvider'
    );
  }

  return { handleKeyEvent, ...context };
};
